import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';

import { TopNavComponent } from './components/top-nav/top-nav.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderSecondaryAComponent } from './components/header-secondary-a/header-secondary-a.component';
import { HeaderSecondaryBComponent } from './components/header-secondary-b/header-secondary-b.component';
import { HeaderSecondaryCComponent } from './components/header-secondary-c/header-secondary-c.component';
import { HeaderSecondaryDComponent } from './components/header-secondary-d/header-secondary-d.component';
import { HeaderSecondaryEComponent } from './components/header-secondary-e/header-secondary-e.component';
import { HeaderSecondaryFComponent } from './components/header-secondary-f/header-secondary-f.component';
import { HeaderSecondaryGComponent } from './components/header-secondary-g/header-secondary-g.component';
import { HeaderSecondaryHComponent } from './components/header-secondary-h/header-secondary-h.component';
import { HeaderSecondaryIComponent } from './components/header-secondary-i/header-secondary-i.component';
import { TaquetsComponent } from '../shared/components/taquets/taquets.component';
import { FaqComponent } from '../shared/components/faq/faq.component';
import { TopNavDirectiveDirective } from './components/top-nav/top-nav-directive.directive';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [
        TopNavComponent, FooterComponent, TaquetsComponent, FaqComponent,
        HeaderSecondaryAComponent, HeaderSecondaryBComponent, HeaderSecondaryCComponent, HeaderSecondaryDComponent,
        HeaderSecondaryEComponent, HeaderSecondaryFComponent, HeaderSecondaryGComponent, 
        HeaderSecondaryHComponent, HeaderSecondaryIComponent, TopNavDirectiveDirective
    ],
    imports: [
        TranslateModule.forChild(),
        CommonModule, RouterModule, MatFormFieldModule, MatDialogModule, MatInputModule,
        FormsModule
    ],
    exports: [
        TopNavComponent, FooterComponent, TaquetsComponent, FaqComponent,
        HeaderSecondaryAComponent, HeaderSecondaryBComponent, HeaderSecondaryCComponent, HeaderSecondaryDComponent,
        HeaderSecondaryEComponent, HeaderSecondaryFComponent, HeaderSecondaryGComponent, HeaderSecondaryHComponent,
        HeaderSecondaryIComponent, TopNavDirectiveDirective
    ]
})
export class SharedModule { }
